<template>
  <v-container id="kidMissionList" fluid>
    <v-row>
      <v-col md="12" cols="12">
        <v-card flat tile>
          <v-card-title>
            <v-row align="center">
              <v-col cols="12" md="6" class="d-flex justify-md-start justify-center">
                <div class="heading-h3">Quests</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-md-end justify-center" v-if="!showAddMissionSection && userRole === 'parent'">
                <v-btn
                  color="secondary"
                  :to="{
                    name: 'CreateMission',
                    params: { id: this.userId },
                  }"
                  >Add a Quest</v-btn
                >
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="d-flex justify-md-start justify-center">
            <div v-if="userRole === 'parent'">
              Below are this kid's current and past quests.
            </div>
            <div v-if="userRole === 'child'">
              When you're done your quests make sure to mark them as complete so you can snag your points!
            </div>
          </v-card-subtitle>
          <MissionListFilters @fetch-missions="fetchMissions" />
          <v-card-text class="add-new-section" v-if="showAddMissionSection">
            <v-row align="center" justify="center" v-if="!isMissionFiltered">
              <v-col cols="12" md="12" class="text-center">
                <div class="body-heading-medium mb-2">No quest yet!</div>
                <div class="mb-2" v-if="userRole === 'parent'">
                  Click "Add a Quest" to create a new quest for your child
                </div>
                <v-btn
                  v-if="userRole === 'parent'"
                  color="secondary"
                  :to="{
                    name: 'CreateMission',
                    params: { id: this.userId },
                  }"
                  >Add a Quest</v-btn
                >
              </v-col>
            </v-row>
            <v-row align="center" justify="center" v-else>
              <v-col cols="12" md="12" class="text-center">
                <div class="body-heading-medium mb-2">No Matched Quest Found!</div>
                <div>
                  Apply different filters to view more quests!
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-item-group v-else>
            <v-row>
              <v-col v-for="mission in missions" :key="mission.id" cols="12" md="12">
                <v-item class="mx-2">
                  <MissionListItem :mission="mission" />
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
          <MissionListPagination @fetch-missions="fetchMissions" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import MissionListItem from "@/components/Mission/MissionListItem";
  import MissionListFilters from "@/components/Mission/MissionListFilters";
  import MissionListPagination from "@/components/Mission/MissionListPagination";

  export default {
    name: "KidMissionList",

    methods: {
      checkMissionCompleteStatus(id) {
        return this.$store.getters.findMissionById(id).complete;
      },

      parseMissionListPaginationInfoToParams() {
        if (!this.$validator.isUndefined(this.missionListPaginationInfo.currentPage) && !this.$validator.isUndefined(this.missionListPaginationInfo.pageSize)) {
          let offset = (this.missionListPaginationInfo.currentPage - 1) * this.missionListPaginationInfo.pageSize;

          return `offset=${offset}&limit=${this.missionListPaginationInfo.pageSize}`;
        } else {
          return "";
        }
      },

      parseTimeRangeFilterToParams() {
        if (!this.$validator.isEmpty(this.missionFilters.timeRange.before_datetime) && !this.$validator.isEmpty(this.missionFilters.timeRange.after_datetime)) {
          return `before_datetime=${this.missionFilters.timeRange.before_datetime}&after_datetime=${this.missionFilters.timeRange.after_datetime}`;
        } else {
          return "";
        }
      },

      parseStatusFilterToParams() {
        if (!this.$validator.isEmpty(this.missionFilters.status)) {
          return `state=${this.missionFilters.status}`;
        } else {
          return "";
        }
      },

      fetchMissions() {
        this.$store.commit("setLoadingStatus", true);

        let paramsString = `${this.parseTimeRangeFilterToParams()}&${this.parseStatusFilterToParams()}&${this.parseMissionListPaginationInfoToParams()}`;

        if (this.userRole === "parent") {
          this.$http
            .get(`/children/${this.userId}/missions?${paramsString}`)
            .then((response) => {
              this.$store.commit("addMissions", response.data.missions);
              this.$store.commit("setMissionListPaginationInfo", {
                total: response.data.pagination.total,
              });
              //If "all status" filter applied, but there is no mission retrieved, that means there was no mission assigned to this kid previously.
              if (!this.$validator.isEmpty(this.missionFilters.status) && this.missionFilters.status === "open,verified,completed" && this.$validator.isEmpty(response.data.missions)) {
                this.$store.commit("setIsMissionFiltered", false);
              } else {
                this.$store.commit("setIsMissionFiltered", true);
              }
              this.$store.commit("setLoadingStatus", false);
            })
            .catch((error) => {
              console.error(error);
              this.$store.commit("setError", {
                message: "Failed to fetch quests",
                type: "error",
              });
              this.$store.commit("setLoadingStatus", false);
            });
        } else {
          this.$http
            .get(`/missions?${paramsString}`)
            .then((response) => {
              this.$store.commit("addMissions", response.data.missions);
              this.$store.commit("setMissionListPaginationInfo", {
                total: response.data.pagination.total,
              });
              //If "all status" filter applied, but there is no mission retrieved, that means there was no mission assigned to this kid previously.
              if (!this.$validator.isEmpty(this.missionFilters.status) && this.missionFilters.status === "open,verified,completed" && this.$validator.isEmpty(this.missionFilters.timeRange) && this.$validator.isEmpty(response.data.missions)) {
                this.$store.commit("setIsMissionFiltered", false);
              } else {
                this.$store.commit("setIsMissionFiltered", true);
              }
              this.$store.commit("setLoadingStatus", false);
            })
            .catch((error) => {
              console.error(error);
              this.$store.commit("setError", {
                message: "Failed to fetch quests",
                type: "error",
              });
              this.$store.commit("setLoadingStatus", false);
            });
        }
      },
    },

    components: { MissionListItem, MissionListFilters, MissionListPagination },

    computed: {
      userRole() {
        return this.$store.getters.userInfo.role;
      },

      userId() {
        return this.$route.params.id ? this.$route.params.id : this.$store.getters.userInfo.id;
      },

      missions() {
        return this.$store.getters.filterMissionsByKidId(this.userId);
      },

      showAddMissionSection() {
        if (this.missions.length > 0) {
          return false;
        }
        return true;
      },

      isMissionFiltered() {
        return this.$store.getters.isMissionFiltered();
      },

      missionFilters() {
        return this.$store.getters.getMissionFilters();
      },

      missionListPaginationInfo() {
        return this.$store.getters.getMissionListPaginationInfo();
      },
    },

    created() {
      this.$store.commit("setMissionFilters", {
        timeRange: {},
        status: "open,verified,completed",
      });
      this.$store.commit("setMissionListPaginationInfo", {
        currentPage: 1,
      });
      this.fetchMissions();
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Kids/KidMissionList.vue